import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import InstantBookingDataService from "../../services/InstantBooking"
import { Loader } from '../../components/Loader/Loader';
import { BookingLeftDetails } from '../../components/BookingView/BookingLeftDetails';
import { BookingRightDetails } from '../../components/BookingView/BookingRightDetails';
import { ExpertInformation } from '../../components/BookingView/ExpertInformation';
import { LeadInformation } from '../../components/BookingView/LeadInformation';
export const ViewInstant = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [row, setRow] = useState<any>();
    const { id } = useParams();
  
    const fetchData = () => {
      setIsLoading(true);
      InstantBookingDataService.getSingleBooking(String(id))
        .then((res) => {
          const data = res.data;
          setRow(data);
          setIsLoading(false);
        })
        .catch((e) => {
          setIsLoading(false);
          console.log(e);
        });
    };
  
    useEffect(() => {
      fetchData();
    }, []);
  
    return (
      <div className="main-wrapper p-3">
        {isLoading ? (
          <Loader />
        ) : (
          <div className="container-fluid bg-white rounded p-4">
  
            {row ? (
              <div className="main-section">
                <div className="row justify-content-center client-detail-sec ">
                  <div className="col-sm-12 card px-5  p-3">
                    <div className="row justify-content-between">
                      <BookingLeftDetails {...row} />
                      <BookingRightDetails {...row} />
                    </div>
                    <div className="row justify-content-between">
                      <LeadInformation {...row.lead_information} />
                      <ExpertInformation {...row.expert_information} />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Loader />
            )}
          </div>
        )}
      </div>
    );
  };
